import React, { useMemo, useState } from "react";
import styles from "./Login.module.less";
import { Divider } from "antd";
import { LOGO_PATH } from "./constants/path";
import LoginWithAzureSSO from "./components/loginWithAzureSSO/LoginWithAzureSSO";
import LoginWithCredentials from "./components/loginWithCredentials/LoginWithCredentials";
import { MsalSSOProvider } from "./providers/MsalSSOProvider";
import { useAuthenticationContext } from "~/providers/AuthenticationProvider";
import CompanySelection from "./components/companySelection/CompanySelection";
import { useLanguage } from "~/hooks/useLanguage";
import { LoginWrapper } from "./LoginWrapper";
import { Navigate } from "react-router-dom";
import { PAGE_HOME } from "~/constants/page";

const Login: React.FC = () => {
  const [isLoginWithPassword, setIsLoginWithPassword] = useState(false);

  const { formatMessage } = useLanguage();
  const { userCompanyInfos, token } = useAuthenticationContext();

  const hasLogged = useMemo(
    () => userCompanyInfos && userCompanyInfos.length > 1,
    [userCompanyInfos],
  );
  if (token) {
    return <Navigate to={PAGE_HOME} />;
  }

  return (
    <LoginWrapper>
      {hasLogged ? (
        <CompanySelection />
      ) : (
        <>
          <div className={styles.loginTitle}>
            <span>{formatMessage("Login.Label.Login")}</span>
            <img style={{ maxWidth: 140 }} src={LOGO_PATH} />
          </div>

          <MsalSSOProvider>
            <LoginWithAzureSSO />
          </MsalSSOProvider>

          <Divider style={{ borderColor: "#b2bec3" }}>
            <span className={styles.orText}>
              {formatMessage("Login.Label.Or")}
            </span>
          </Divider>
          <div className={styles.signWithPasswordContainer}>
            {isLoginWithPassword ? (
              <LoginWithCredentials />
            ) : (
              <span
                onClick={() => setIsLoginWithPassword(true)}
                className={styles.signWithPassword}
              >
                {formatMessage("Login.Label.LoginWithCredentials")}
              </span>
            )}
          </div>
        </>
      )}
    </LoginWrapper>
  );
};

export default Login;
